import getDatesIntervalWithSubtractMinutes from '../../../localUtils/getDatesIntervalWithSubtractMinutes'

export default function getFifteenMinutesAgo() {
  const fifteenMinutes = 15

  const dates = getDatesIntervalWithSubtractMinutes(fifteenMinutes)

  const options = {
    name: 'FIFTEEN_MINUTES_AGO',
    label: '15 Minutos',
    ...dates,
  }

  return options
}
